import { IDashboardFilters, IDashboardPlateData, TDashboardPlatesData } from '../types/dashboard';
import { ICrumb } from '~/view/components/Controls/Crumbs';

export const dashboardPreventId: string = 'prevent-plate';

export enum DashboardDatePeriods {
  DAY = 'd',
  WEEK = 'w',
  MONTH = 'm',
}

export enum DashboardPlates {
  ORDERS = 'orders',
  REVENUE = 'revenue',
  CRM = 'crm',
  MARKETING = 'marketing',
}

export enum DashboardCrumbs {
  BRANCHES = 'branches',
  ZONES = 'areas',
  CHANNELS = 'channels',
}

export const dashboardTabs: ICrumb[] = [
  { value: DashboardDatePeriods.DAY, label: 'day' },
  { value: DashboardDatePeriods.WEEK, label: 'week' },
  { value: DashboardDatePeriods.MONTH, label: 'month' },
];

// Dashboard step 2
export const dashboardCrumbs: ICrumb[] = [
  // { value: DashboardCrumbs.BRANCHES, label: 'top_branches' },
  // { value: DashboardCrumbs.ZONES, label: 'delivery_zones' },
  { value: DashboardCrumbs.CHANNELS, label: 'ordering_channels' },
];

export const defaultDashboardPlateData: IDashboardPlateData = {
  mainValue: 0,
  mainPercent: 0,
  secondaryValue: 0,
  secondaryPercent: 0,
  conclusionValue: 0,
};
export const defaultDAshboardPlatesData: TDashboardPlatesData = {
  [DashboardPlates.ORDERS]: defaultDashboardPlateData,
  [DashboardPlates.REVENUE]: defaultDashboardPlateData,
  [DashboardPlates.CRM]: defaultDashboardPlateData,
  [DashboardPlates.MARKETING]: defaultDashboardPlateData,
};

export const defaultDashboardFilters: IDashboardFilters = {
  datePeriod: DashboardDatePeriods.MONTH,
};
